export default defineNuxtPlugin(async (NuxtApp) => {
  const { AppCookieNames } = await import("~/assets/constants/ecomApi");
  const { $customClientErrorHandler } = useNuxtApp();

  const { useAuthStore } = await import("~/stores/auth.store");
  const authStore = useAuthStore();
  const auth_token = useCookie(AppCookieNames.CustomerJWT);
  if (!auth_token.value || !auth_token.value.value) {
    authStore.user = null;
    return;
  }

  try {
    const runtimeConfig = useRuntimeConfig();
    const response = await authStore.setAuthUserByToken(
      auth_token.value.value,
      NuxtApp,
      runtimeConfig
    );

    if (response && response.id) {
      const { useRootStore } = await import("~/stores/root.store");
      const rootStore = useRootStore();
      authStore.user = rootStore.clone(response);
    }
  } catch (error) {
    const errorMeta = { authError: true };
    $customClientErrorHandler?.(
      error,
      "critical",
      "Auth Plugin Error - trying to set auth user by token using setAuthUserByToken()",
      errorMeta
    );
    authStore.user = null;
  }
});
